export const originType = {
    shopAll: 'shop-all',
    sale: 'sale',
    search: 'search',
    category: 'category'
}
